import { __awaiter } from '../../_virtual/_tslib.js';

function handleMutateResponse(mutateFn, handlerParams) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const res = yield mutateFn(handlerParams);
            if (res.ok) {
                const response = yield res.json();
                return { success: true, data: response.data, response: response };
            }
            if (!res.ok) {
                const msg = (yield res.json()).message;
                const error = { message: msg };
                return { success: false, data: null, error };
            }
        }
        catch (e) {
            return { success: false };
        }
        return { success: false };
    });
}

export { handleMutateResponse };
//# sourceMappingURL=handleMutateResponse.js.map
